// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Icon/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Icon} from '@sail/ui';
import {addCircle} from '@sail/icons/react/Icon';

export const Basic = () => <Icon icon={addCircle} size="small" />;
